<template>
  <transition name="modal">
    <div class="modal-mask manage-screens">
      <div class="modal-wrapper" v-on:click.self="$emit('close')">
        <div class="modal-container">

          <div class="modal-header">
            <div class="title">Edit Production</div>
            <button class="modal-close tb-btn tb-btn-text sm low-em" v-on:click.stop.prevent="$emit('close')"><span class="icon icon-cross"></span></button>
          </div>

          <div class="modal-body">
            <form v-on:submit.prevent="save">
              <label class="tb-label">Production Title</label>
              <input
                id="productionTitle"
                type="text"
                ref="title"
                class="tb-input"
                v-model="title"
                v-on:keyup.right.stop
                v-on:keyup.left.stop placeholder="Production title"
              >
              <button type="submit" class="hidden"></button>
            </form>
          </div>

          <div class="modal-footer">
            <button class="tb-btn tb-btn-contained medium-em margin-left-sm" data-tracking="production_edit_production_button" name="Save" v-on:click="save">
              <span>Save</span>
            </button>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      title: '',
    };
  },

  mounted() {
    this.$refs.title.focus();
    this.title = this.production.title;
  },

  methods: {
    ...mapActions(['updateProduction']),

    async save() {
      this.$store.dispatch('startLoader');

      // Send name change to other clients
      this.$store.dispatch('updateTimeline');

      try {
        await this.updateProduction({
          id: this.production._id,
          payload: { title: this.title },
        });
      } catch (err) {
        this.errorToast('There was an error saving your production title. Please try again.');
        this.$store.dispatch('stopLoader');
        return;
      }

      document.querySelector('title').innerText = `${this.production.title} - Tagboard Producer`;
      this.editing = false;
      this.successToast('Production saved!');
      this.$emit('close');
      this.$store.dispatch('stopLoader');
    },
  },

  computed: {
    user() {
      return this.$store.state.user;
    },

    production() {
      return this.$store.state.production.production;
    },

    isFormInvalid() {
      return Object.keys(this.fields).some((key) => this.fields[key].invalid);
    },
  },
};
</script>
